import * as React from 'react';
import DatePicker from './DatePicker';
import { PickerTimeProps } from 'antd/es/date-picker/generatePicker';
import { formatInTimeZone } from 'date-fns-tz';

export interface TimePickerProps extends Omit<PickerTimeProps<Date>, 'picker'> { }

const TimePicker = React.forwardRef<any, TimePickerProps>((props, ref) => {
  return <DatePicker {...props} picker="time" mode={undefined} ref={ref} format={(date) => formatInTimeZone(date, 'Asia/Ho_Chi_Minh', "dd/MM/yyyy HH:mm:ss")} />;
});

TimePicker.displayName = 'TimePicker';

export default TimePicker;